import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/dome/index.vue";
import Login from "../views/login.vue";
import RegionScreen from "../views/ReginScreen.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/Login",
    name: "Login",
    component: Login
  },
  {
    path: "/",
    name: "Index",
    component: () => import("../views/Index.vue")
  },
  {
    path: "/Home",
    name: "Home",
    component: Home
  },
  /* {
		path: '/Index',
		name: 'Index',
		component: () => import('../views/Index.vue') 
	}, */
  {
    path: "/Details",
    name: "Details",
    component: () => import("../views/Details.vue")
  },
  {
    path: "/Screen",
    name: "Screen",
    component: () => import("../views/Screen.vue")
  },
  {
    path: "/RegionScreen",
    name: "RegionScreen",
    component: RegionScreen
  },
  {
    path: "/Policy",
    name: "Policy",
    component: () => import("../views/Policy.vue")
  },
  {
    path: "/Video",
    name: "Video",
    component: () => import("../views/Video.vue")
  },
  {
    path: "/Center",
    name: "Center",
    component: () => import("../views/Center.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});
router.beforeEach((to, from, next) => {
  if (to.path === "/Login" || to.path === "/") {
    next();
  } else {
    let token = localStorage.getItem("Authorization");
    if (token === null || token === "") {
      next("/Login");
    } else {
      next();
    }
  }
});

export default router;
